<div class="action-footer-container">
  <app-button  [buttonName]="buttonName" (onClickEvent)="onClickAction()" [disabled]="disbaleButton"></app-button>
</div>
